var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3172_29329)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.988 0C18.624 0 24 5.376 24 12C24 18.624 18.624 24 11.988 24C5.364 24 0 18.624 0 12C0 5.376 5.364 0 11.988 0ZM12 2.4C10.7392 2.39961 9.49068 2.64765 8.32577 3.12995C7.16087 3.61226 6.10242 4.31937 5.2109 5.2109C4.31937 6.10242 3.61226 7.16087 3.12995 8.32577C2.64765 9.49068 2.39961 10.7392 2.4 12C2.4 17.304 6.696 21.6 12 21.6C17.304 21.6 21.6 17.304 21.6 12C21.6 6.696 17.304 2.4 12 2.4ZM12.6 6V12.3L18 15.504L17.1 16.98L10.8 13.2V6H12.6Z",
    fill: "#CE623E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3172_29329"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimer);
export default __webpack_public_path__ + "static/media/timer.dca7491a670f543510b9359666a41c2b.svg";
export { ForwardRef as ReactComponent };